import SimpleAccordion from './SimpleAccordion';

export default SimpleAccordion;
